import React from 'react';
import './AppTop.css';

class AppTop extends React.Component {

  render() {
    return (
      <div id='headbar' > 
        <div id='logo'>
          <h1 style={{display:'inline'}}>
            <a href='/'> Opstool</a>
          </h1>
        </div>
        <div id='toprightlinks'>
          <span className='link1'><a href='/'>工具</a></span>
          <span className='link2'><a href='#blog/'>博客</a></span>
          <span className='link3'></span>
          <span></span>
        </div>
      </div>
    );
  }
}

export default AppTop;